(function () {
  // Adjusts iframe sizing inside .video-hero elements so portrait videos
  // fill vertically on mobile and landscape videos fill horizontally on desktop.
  // It compares the container's aspect ratio (width/height) to the target
  // video aspect ratio and sets inline width/height accordingly.

  var MOBILE_BREAKPOINT = 990; // matches CSS media query
  var MOBILE_ASPECT = 9 / 16; // width / height for portrait videos
  var DESKTOP_ASPECT = 16 / 9; // width / height for landscape videos

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
  }

  function adjustHero(hero) {
    if (!hero) return;
    var rect = hero.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var containerAspect = rect.width / rect.height;

    if (isMobile()) {
      var iframe = hero.querySelector('.video-hero__mobile-video iframe');
      if (!iframe) return;
      // If container is taller than the video's aspect (narrower), size by height
      if (containerAspect < MOBILE_ASPECT) {
        iframe.style.width = 'auto';
        iframe.style.height = '100%';
      } else {
        // otherwise size by width
        iframe.style.width = '100%';
        iframe.style.height = 'auto';
      }
    } else {
      var iframe = hero.querySelector('.video-hero__desktop-video iframe');
      if (!iframe) return;
      if (containerAspect < DESKTOP_ASPECT) {
        iframe.style.width = 'auto';
        iframe.style.height = '100%';
      } else {
        iframe.style.width = '100%';
        iframe.style.height = 'auto';
      }
    }
  }

  function adjustAll() {
    document.querySelectorAll('.video-hero').forEach(function (hero) {
      adjustHero(hero);
    });
  }

  // Observe size changes to each .video-hero
  function observeHeroes() {
    var heroes = document.querySelectorAll('.video-hero');
    heroes.forEach(function (hero) {
      try {
        var ro = new ResizeObserver(function () {
          adjustHero(hero);
        });
        ro.observe(hero);
      } catch (e) {
        // ResizeObserver not supported: fall back to window resize
      }
    });
  }

  // Recalculate on resize/orientationchange and on DOM ready
  window.addEventListener('resize', adjustAll, { passive: true });
  window.addEventListener('orientationchange', adjustAll, { passive: true });

  document.addEventListener('DOMContentLoaded', function () {
    observeHeroes();
    // Delay first run to allow iframes to be parsed/loaded
    setTimeout(adjustAll, 50);
  });
})();
